import { Button, Dialog, DialogContent, DialogTitle, IconButton, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import BayarPendaftaran from "./BayarPendaftaran";
import { JENIS_BAYAR } from "../../helper/Constant";
import TabPanel from "../general/TabPanel";
import { WhatsApp } from "@mui/icons-material";
import DialogCommonTitle from "./DialogCommonTitle";

function DialogPembayaran({ isOpen, handleClose, rowDetail }) {
    const [panelValue, setPanelValue] = useState(0);

    if (!rowDetail || !rowDetail.rawData) {
        return (
            <></>
        )
    }

    return (
        <>
            <Dialog fullWidth maxWidth={"md"} open={isOpen} onClose={handleClose}>
                <DialogTitle>
                    <DialogCommonTitle dialogTitle={"Detail Pembayaran"} detailName={rowDetail.nama} noWa={rowDetail.waNo}></DialogCommonTitle>
                </DialogTitle>
                <DialogContent>
                    <Tabs variant="fullWidth" value={panelValue} onChange={(event, newValue) => { setPanelValue(newValue); }}>
                        <Tab label="Biaya Pendaftaran"></Tab>
                        <Tab label="Biaya Daftar Ulang"></Tab>
                    </Tabs>
                    <TabPanel value={panelValue} index={0}>
                        <BayarPendaftaran typeBayar={JENIS_BAYAR.PENDAFTARAN} idSantri={rowDetail.id} dataBayar={rowDetail.rawData.bayarPendaftaran}></BayarPendaftaran>
                    </TabPanel>
                    <TabPanel value={panelValue} index={1}>
                        <BayarPendaftaran typeBayar={JENIS_BAYAR.DAFTAR_ULANG} idSantri={rowDetail.id} dataBayar={rowDetail.rawData.bayarReregistrasi}></BayarPendaftaran>
                    </TabPanel>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default DialogPembayaran;